import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Services from "../pages/services/page";
import Cybersecurity from "../pages/services/cybersecurity/page";
import Software from "../pages/services/software/page";
import Consulting from "../pages/services/consulting/page";
import Ahis from "../pages/ahis/page";
import Contact from "../pages/contact/page";
import Privacy from "../pages/privacy/page";
import Terms from "../pages/terms/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/services", element: <Services /> },
  { path: "/services/cybersecurity", element: <Cybersecurity /> },
  { path: "/services/software", element: <Software /> },
  { path: "/services/consulting", element: <Consulting /> },
  { path: "/ahis", element: <Ahis /> },
  { path: "/contact", element: <Contact /> },
  { path: "/privacy", element: <Privacy /> },
  { path: "/terms", element: <Terms /> },
  { path: "*", element: <NotFound /> },
];

export default routes;